export default __webpack_public_path__ + "static/Silvia-2e3ac5f35523a0f7035dd6785e753f4e.jpg";